import { Table, TableColumnsType } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getDashboardTeacher } from "../../../api/dashboard.api";
import useAxios from "../../../hooks/useAxios";
import { IGetDashboardTeacher } from "../../../models/dashboard.model";
import { RootState } from "../../../store/rootReducer";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Subtitle from "./Subtitle";

const Teacher = () => {
  const { t } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetDashboardTeacher>();

  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (currentCampus) {
      execute(getDashboardTeacher(currentCampus));
    }
  }, [currentCampus]);

  useEffect(() => {
    if (res && !isLoading) {
      const _data: any = [];
      res.data?.todayStatusInfo?.forEach(item => _data.push(item));

      const total = res.data?.totalStatusInfo;
      _data.push({
        memberCode: 'total',
        memberKorName: t('class.dashboard.column32'),
        memberEngName: 'Total',
        chargeClassCount: total?.totalClassCount,
        reCount: total?.totalReCount,
        s1Count: total?.totalS1Count,
        s2Count: total?.totalS2Count,
        reRegistRate: total?.reRegistRate,
      });

      setData(_data);
    }
  }, [res, isLoading]);

  const columns: TableColumnsType<any> = [
    {
      title: t('class.dashboard.column28'),
      dataIndex: 'memberKorName',
      key: 'memberKorName',
      align: 'center',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'chargeClassCount',
      key: 'chargeClassCount',
      align: 'center',
    },
    {
      title: t('class.dashboard.column29'),
      dataIndex: 'reCount',
      key: 'reCount',
      align: 'center',
    },
    {
      title: t('class.dashboard.column30'),
      dataIndex: 's1Count',
      key: 's1Count',
      align: 'center',
    },
    {
      title: t('class.dashboard.column5'),
      dataIndex: 's2Count',
      key: 's2Count',
      align: 'center',
    },
    {
      title: t('class.dashboard.column31'),
      dataIndex: 'reRegistRate',
      key: 'reRegistRate',
      align: 'center',
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <Subtitle
        text={t('class.dashboard.title11')}
        path="/statistics/student-enroll"
      />
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={data}
        rowClassName={(record: any) => record.memberCode === 'total' ? 'chosen' : 'pointer'}
        pagination={{
          pageSize: 99999,
        }}
      />
    </>
  );
}

export default Teacher;
